import {
  Box
} from "@chakra-ui/react";

const BoxData = ({ data }) => {
    return (
      <Box as="span" fontWeight="600" textColor="black" ml=".2rem">
        { data ?  data : <Box as="span" fontWeight="300" color="gray.borders" letterSpacing="2px"> --- </Box> }
      </Box>
    );
};

export default BoxData;